import get from 'lodash/get';
import each from 'lodash/each';
import groupBy from 'lodash/groupBy';

import config from 'config';
import logger from '../../utils/logger';

class TikTok {
  _init(state, commit, id) {
    if (!state.currentIds.tiktok.includes(id)) {
      ttq.load(id)

      commit('trackId', { property: 'tiktok', value: id });

      logger.log(`${id} initialize.`);
    } else {
      logger.log(`${id} already initialized.`);
    }
  }

  _track(id, event, payload, type) {
    if (payload) {
      ttq.instance(id).track(event, payload);

      logger.log(`${type ? `${type} ` : ''}TikTok ${id} ${event} event with payload:`);

      logger.log(payload);
    } else {
      ttq.track(event);

      logger.log(`${type ? `${type} ` : ''}TikTok ${id} ${event} event.`);
    }
  }

  viewPage({ state, commit }) {
    logger.groupCollapsed('VS TikTok');

    this._init(state, commit, config.TIKTOK);

    this._track(config.TIKTOK, 'Browse');

    logger.groupEnd();
  }

  viewSales({ state, commit }) {
    logger.groupCollapsed('VS TikTok');

    if (logger.checkRetargeting(state.campaign.tracking.global.disable_vs_retargeting)) {
      let payload = {
        content_type: 'product_group',
        content_id: `${state.campaign.analytics_cid}`,
        content_name: state.campaign.name,
      };

      if (state.campaign.category) {
        payload.content_category = state.campaign.category;
      }

      this._init(state, commit, config.TIKTOK);

      this._track(config.TIKTOK, 'Browse', payload);

      this._track(config.TIKTOK, 'ViewContent', {
        ...payload,
        currency: 'USD',
        price: parseFloat(state.product.price),
        value: parseFloat(state.product.price),
      });
    } else {
      logger.log('VS TikTok disabled.');
    }

    logger.groupEnd();
  }

  viewThankYou({ state, commit }) {
    logger.groupCollapsed('VS TikTok');

    let payload = {
      contents: [],
      currency: 'USD',
      value: 0,
    };

    each(state.order.orders, order => {
      if (logger.checkRetargeting(state.order.tracking[order.analytics_cid].global.disable_vs_retargeting)) {
        each(order.products, item => {
          payload.contents.push({
            content_id: `${order.analytics_cid}`,
            quantity: item.quantity,
            price: Math.round(item.discounted_price / item.quantity * 100) / 100,
            content_category: order.campaign_category,
            content_name: order.campaign_name,
            content_type: 'product',
          });

          payload.value += item.discounted_price;
        });
      }
    });

    payload.value = Math.round(payload.value * 100) / 100;

    if (payload.contents.length) {
      this._init(state, commit, config.TIKTOK);

      this._track(config.TIKTOK, 'Browse', payload);

      this._track(config.TIKTOK, 'Purchase', payload);
    } else {
      logger.log('VS TikTok disabled.');
    }

    logger.groupEnd();
  }

  addToCart({ state, commit }) {
    logger.groupCollapsed('VS TikTok');

    if (logger.checkRetargeting(state.campaign.tracking.global.disable_vs_retargeting)) {
      let payload = {
        content_id: `${state.campaign.analytics_cid}`,
        content_type: 'product',
        content_name: state.campaign.name,
        currency: 'USD',
        price: parseFloat(state.product.price),
        quantity: state.quantity,
      };

      if (state.campaign.category) {
        payload.content_category = state.campaign.category;
      }

      this._init(state, commit, config.TIKTOK);

      this._track(config.TIKTOK, 'AddToCart', payload);
    } else {
      logger.log('VS TikTok disabled.');
    }

    logger.groupEnd();
  }

  initiateCheckout({ state, commit }) {
    logger.groupCollapsed('VS TikTok');

    let payload = {
      contents: [],
      currency: 'USD',
      value: 0,
    };

    each(state.cart.items, item => {
      if (logger.checkRetargeting(state.cart.tracking[item.analytics_cid].global.disable_vs_retargeting)) {
        payload.contents.push({
          content_id: `${item.analytics_cid}`,
          quantity: item.quantity,
          price: item.price_per_unit,
          content_category: item.campaign_category,
          content_name: item.campaign_name,
          content_type: 'product',
        });

        payload.value += item.price;
      }
    });

    payload.value = Math.round(payload.value * 100) / 100;

    if (payload.contents.length) {
      this._init(state, commit, config.TIKTOK);

      this._track(config.TIKTOK, 'StartCheckout', payload);
    } else {
      logger.log('VS TikTok disabled.');
    }

    logger.groupEnd();
  }

  completeOrder({ state, commit }) {
    logger.groupCollapsed('VS TikTok');

    let payload = {
      contents: [],
      currency: 'USD',
      value: 0,
    };

    each(state.cart.items, item => {
      if (logger.checkRetargeting(state.cart.tracking[item.analytics_cid].global.disable_vs_retargeting)) {
        payload.contents.push({
          content_id: `${item.analytics_cid}`,
          quantity: item.quantity,
          price: item.price_per_unit,
          content_category: item.campaign_category,
          content_name: item.campaign_name,
          content_type: 'product',
        });

        payload.value += item.price;
      }
    });

    payload.value = Math.round(payload.value * 100) / 100;

    if (payload.contents.length) {
      this._init(state, commit, config.TIKTOK);

      this._track(config.TIKTOK, 'Checkout', payload);
    } else {
      logger.log('VS TikTok disabled.');
    }

    logger.groupEnd();
  }

  register({ state, commit }) {
    logger.groupCollapsed('VS TikTok');

    this._init(state, commit, config.TIKTOK);

    this._track(config.TIKTOK, 'Registration');

    logger.groupEnd();
  }

  search({ rootState, state, commit }) {
    logger.groupCollapsed('VS TikTok');

    this._init(state, commit, config.TIKTOK);

    this._track(config.TIKTOK, 'Search', {
      query: rootState.marketplace.search,
    });

    logger.groupEnd();
  }

  clientViewSales({ state, commit }) {
    logger.groupCollapsed('Client Tiktok');

    let infoGlobal = state.campaign.tracking.global.tiktok,
      infoCampaign = state.campaign.tracking.campaign.tiktok,
      payload = {
        content_type: 'product_group',
        content_id: `${state.campaign.slug}`,
        content_name: state.campaign.name,
      },
      track = (id, payload, type) => {
        this._init(state, commit, id);

        this._track(id, 'Browse', payload, type);

        this._track(id, 'ViewContent', {
          ...payload,
          currency: 'USD',
          price: parseFloat(state.product.price),
          value: parseFloat(state.product.price),
        }, type);
      };

    if (logger.checkCampaign(infoCampaign)) {
      track(infoCampaign, payload, 'Campaign specific');
    }

    if (logger.checkGlobal(infoGlobal, infoCampaign)) {
      track(infoGlobal, payload, 'Global');
    }

    logger.groupEnd();
  }

  clientViewThankYou({ state, commit }) {
    logger.groupCollapsed('Client Tiktok');

    let track = (id, payload, type) => {
      this._init(state, commit, id);

      this._track(id, 'Browse', payload, type);

      this._track(id, 'Purchase', payload, type);
    };

    each(state.order.orders, order => {
      logger.groupCollapsed(order.campaign_name);

      let infoGlobal = state.order.tracking[order.analytics_cid].global.tiktok,
        infoCampaign = state.order.tracking[order.analytics_cid].campaign.tiktok,
        payload = {
          contents: [],
          currency: 'USD',
          value: 0,
        };

      each(order.products, item => {
        payload.contents.push({
          content_id: `${order.campaign_slug}`,
          quantity: item.quantity,
          price: Math.round(item.discounted_price / item.quantity * 100) / 100,
          content_category: order.campaign_category,
          content_name: order.campaign_name,
          content_type: 'product',
        });

        payload.value += item.discounted_price;
      });

      payload.value = Math.round(payload.value * 100) / 100;

      if (logger.checkCampaign(infoCampaign)) {
        track(infoCampaign, payload, 'Campaign specific');
      }

      if (logger.checkGlobal(infoGlobal, infoCampaign)) {
        track(infoGlobal, payload, 'Global');
      }

      logger.groupEnd();
    });

    logger.groupEnd();
  }

  clientAddToCart({ state, commit }) {
    logger.groupCollapsed('Client Tiktok');

    let infoGlobal = state.campaign.tracking.global.tiktok,
      infoCampaign = state.campaign.tracking.campaign.tiktok,
      payload = {
        content_id: `${state.campaign.slug}`,
        content_type: 'product',
        content_name: state.campaign.name,
        currency: 'USD',
        price: parseFloat(state.product.price),
        quantity: state.quantity,
      },
      track = (id, payload, type) => {
        this._init(state, commit, id);

        this._track(id, 'AddToCart', payload, type);
      };

    if (state.campaign.category) {
      payload.content_category = state.campaign.category;
    }

    if (logger.checkCampaign(infoCampaign)) {
      track(infoCampaign, payload, 'Campaign specific')
    }

    if (logger.checkGlobal(infoGlobal, infoCampaign)) {
      track(infoGlobal, payload, 'Global')
    }

    logger.groupEnd();
  }

  clientInitiateCheckout({ state, commit }) {
    logger.groupCollapsed('Client Tiktok');

    each(groupBy(state.cart.items, 'analytics_cid'), group => {
      let firstItem = group[0],
        infoGlobal = state.cart.tracking[firstItem.analytics_cid].global.tiktok,
        infoCampaign = state.cart.tracking[firstItem.analytics_cid].campaign.tiktok,
        payload = {
          contents: [],
          currency: 'USD',
          value: 0,
        },
        track = (id, payload, type) => {
          this._init(state, commit, id);

          this._track(id, 'StartCheckout', payload, type);
        };

      logger.groupCollapsed(firstItem.campaign_name);

      each(group, item => {
        payload.contents.push({
          content_id: `${item.campaign_slug}`,
          quantity: item.quantity,
          price: item.price_per_unit,
          content_category: item.campaign_category,
          content_name: item.campaign_name,
          content_type: 'product',
        });

        payload.value += item.price;
      });

      payload.value = Math.round(payload.value * 100) / 100;

      if (logger.checkCampaign(infoCampaign)) {
        track(infoCampaign, payload, 'Campaign specific');
      }

      if (logger.checkGlobal(infoGlobal, infoCampaign)) {
        track(infoGlobal, payload, 'Global');
      }

      logger.groupEnd();
    });

    logger.groupEnd();
  }

  clientCompleteOrder({ state, commit }) {
    logger.groupCollapsed('Client Tiktok');

    each(groupBy(state.cart.items, 'analytics_cid'), group => {
      let firstItem = group[0],
        infoGlobal = state.cart.tracking[firstItem.analytics_cid].global.tiktok,
        infoCampaign = state.cart.tracking[firstItem.analytics_cid].campaign.tiktok,
        payload = {
          contents: [],
          currency: 'USD',
          value: 0,
        },
        track = (id, payload, type) => {
          this._init(state, commit, id);

          this._track(id, 'Checkout', payload, type);
        };

      logger.groupCollapsed(firstItem.campaign_name);

      each(group, item => {
        payload.contents.push({
          content_id: `${item.campaign_slug}`,
          quantity: item.quantity,
          price: item.price_per_unit,
          content_category: item.campaign_category,
          content_name: item.campaign_name,
          content_type: 'product',
        });

        payload.value += item.price;
      });

      payload.value = Math.round(payload.value * 100) / 100;

      if (logger.checkCampaign(infoCampaign)) {
        track(infoCampaign, payload, 'Campaign specific');
      }

      if (logger.checkGlobal(infoGlobal, infoCampaign)) {
        track(infoGlobal, payload, 'Global');
      }

      logger.groupEnd();
    });

    logger.groupEnd();
  }

  clientViewCollection({ rootState, state, commit }) {
    logger.groupCollapsed('Client Tiktok');

    let info = rootState.collection.info,
      payload = {
        content_name: info.name,
        store_url: info.uri,
        content_type: 'product_group',
      },
      id = get(info, 'tracking.global.tiktok');

    if (id) {
      this._init(state, commit, id);

      this._track(id, 'Browse', payload, 'Global');

      this._track(id, 'ViewContent', payload, 'Global');
    } else {
      logger.log('Global not configured');
    }

    logger.groupEnd();
  }
};

export default new TikTok();